import { Component } from 'react';
import { connect } from 'react-redux';

class StudentsComponent extends Component {

    render() {
        return (
            <div>
                <p>{this.props.authenticatedUser.name} {this.props.authenticatedUser.surname} track your students.</p>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        authenticatedUser: state.authenticatedUser,
        mainPageTitle: state.mainPageTitle
    }
};

export default connect(mapStateToProps)(StudentsComponent);